module.exports = __webpack_public_path__ + "static/media/shopping-cart-remove.c226c095.png";